<script setup>
const props = defineProps(['partner'])
</script>

<template>
    <a :href="partner.link" class="group w-full xl:aspect-square [perspective:1000px]">
        <div class="relative h-full w-full rounded-xl transition-all duration-700 [transform-style:preserve-3d] xl:group-hover:[transform:rotateY(180deg)] bg-gradient-to-b from-mint-100 to-white">
            <div class="absolute inset-0 [backface-visibility:hidden] xl:flex hidden items-center justify-center">
                <img :src="partner.logo" alt="">
            </div>
            <div class="xl:absolute top-0 left-0 w-full rounded-xl h-full xl:p-8 p-6 flex flex-col items-start xl:[transform:rotateY(180deg)] [backface-visibility:hidden] bg-gradient-to-b from-mint-100 to-white">
                <img class="lg:h-14 md:h-12 h-16 md:mb-8 mb-4 xl:hidden block" :src="partner.logo" alt="">
                <p class="2xl:text-sm text-xs leading-relaxed" v-html="partner.bio"></p>
                <div class="xl:absolute bottom-3 right-3 bg-gradient-to-br from-lavendar-100 via-ruby-100 to-coral-100 text-white text-xs uppercase font-bold px-3 py-1 rounded-md xl:mt-0 mt-4">Visit us</div>
            </div>
        </div>
    </a>
</template>